<template>
  <div class="award-wrapper" :class="{'mt-5': margin}">
    <div class="container">
      <div class="awards-img flex-direction-lg-row">
        <img class="awards__counter" :src="require(`@/assets/complete/trusted-clients-${$i18n.locale}.png`)">
        <img class="awards__counter order-xl-2" :src="require(`@/assets/complete/years-of-experience-${$i18n.locale}.png`)">
        <div class="awards-img">
          <div class="award-img"><img src="@/assets/complete/chrr-5-star-hr-consultant-2021.png"></div>
          <div class="award-img"><img src="@/assets/complete/professional-services.png"></div>
          <div class="award-img"><img src="@/assets/complete/gptw-certified-sep-2018-2019.png"></div>
          <div class="award-img"><img src="@/assets/complete/2019-ctgc-cmyk.png"></div>
          <div class="award-img"><img src="@/assets/complete/growth-500.png"></div>
          <div class="award-img"><img src="@/assets/complete/profit-500.png"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Awards',
  props: {
    margin: {
      required: false,
      default: true
    }
  }
}
</script>

<style lang="sass" scoped>
.award-wrapper
  padding: 30px 0
  color: $white
  position: relative
  width: 100vw
  height: 100%
  left: 50%
  transform: translateX(-50vw)
  z-index: 0
  background-color: $purple

.awards-img
  flex-grow: 1
  justify-content: space-around
  display: flex
  margin: 0 -10px
  +media-breakpoint-down(lg)
    flex-wrap: wrap

  .awards-img
    margin: 0
    +media-breakpoint-down(lg)
      flex-wrap: nowrap

  .award-img
    flex: 1 1 auto
    display: flex
    justify-content: center
    margin: 10px
    max-height: 80px
    +media-breakpoint-down(xxs)
      width: 30%

    img
      max-width: 100%
      max-height: 100%
      object-fit: contain

img.awards__counter
  margin: 10px
  max-height: 70px
  +media-breakpoint-down(sm)
    flex: 1 1 auto
    min-width: 30%
    max-height: 67px
    object-fit: contain
  +media-breakpoint-down(xxs)
    max-height: 50px
    width: 30%
</style>



// WEBPACK FOOTER //
// src/components/ui/products/Awards.vue